import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.ends-with";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.replace";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import get from 'lodash/get';
import clone from 'lodash/cloneDeep';
import set from 'lodash/set';
import { mapState } from 'vuex';
import isEqual from 'lodash/isEqual';
import { VExpansionPanel, VExpansionPanelContent, VExpansionPanelHeader, VExpansionPanels, VSpacer } from 'vuetify/lib';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { templateMixin } from './templateMixin';
export default {
  name: 'CoreDetailsPage',
  components: {
    VExpansionPanel: VExpansionPanel,
    VExpansionPanels: VExpansionPanels,
    VExpansionPanelHeader: VExpansionPanelHeader,
    VExpansionPanelContent: VExpansionPanelContent,
    VSpacer: VSpacer
  },
  mixins: [templateMixin],
  props: {
    /**
     * Function to fetch the item to display
     * @type {Function}
     * @required
     * @return {Promise} - The item to display
     */
    fetchItem: {
      type: Function,
      required: true
    },

    /**
     * External fetch parameters to be passed into fetchItem(), changes will trigger a refetch
     * @type {Object}
     * @default {}
     */
    externalFetchParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * Function to save the updated item
     * @type {Function}
     * @arg {Object} item - The updated item
     * @required
     * @return {Promise} - The updated item
     */
    saveItem: {
      type: Function,
      required: true
    },

    /**
     * The headline of the page
     * @type {String} | {Function}
     * @required
     * @return {String}
     */
    headline: {
      type: [String, Function],
      required: true
    },

    /**
     * The subtitle of the page
     * @type {String} | {Function}
     * @required
     * @return {String}
     */
    subtitle: {
      type: [String, Function],
      required: true
    },

    /**
     * Tabs to show on the page
     * @type {Array} - Array of objects with the following properties:
     *  - label {String} - The label of the tab
     *  - urlHashbang {String} - The hashbang to use for the tab
     *  - rows {Array} - Array of objects with the following properties:
     *    - class {String} - The class to apply to the row
     *    - columns {Array} - Array of objects with the following properties:
     *      - cols {Number} - The number of columns to span
     *      - sm {Number} - The number of columns to span on small screens
     *      - md {Number} - The number of columns to span on medium screens
     *      - lg {Number} - The number of columns to span on large screens
     *      - class {String} - The class to apply to the column
     *      - field {Object} - The field to display in the column with the following properties:
     *         - label {String} - The label of the field
     *         - key {String} - The key of the field in the item
     *         - icon {String} - The icon to display next to the field
     *         - type {String} - The type of the field
     *         - if {Function} - Function to determine if the field should be displayed
     *      - rows {Array} - Array of objects with the same properties as parent rows
     * @required
     */
    tabs: {
      type: Array,
      required: true
    },

    /**
     * Whether the page is in edit mode
     * @type {Boolean}
     * @default false
     */
    editMode: {
      type: Boolean,
      default: false
    },

    /**
     * Header buttons
     * @type {Array} [{ dataCy?: string, color?: string, type?: string, tooltip?: string, href?: string, target?: string, icon?: string, action?: string }]
     */
    headerButtons: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },

    /**
     * The href to navigate to when closing the page
     * @type {String}
     */
    parentHref: {
      type: String,
      default: null
    },

    /**
     * Function to map the redirect URL after saving the item (gets the created item as argument)
     * @type {Function}
     * @default null
     * @return {String} - The redirect URL
     */
    postCreateRedirectUrlMapper: {
      type: Function,
      default: null
    },
    isFormValid: {
      type: Boolean,
      default: true
    },
    externalIsChanged: {
      type: Boolean,
      default: false
    },

    /**
     * The name of the item, used e.g. in snack messages
     * @type {String}
     */
    itemName: {
      type: String,
      default: 'Item'
    },
    templateInformation: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      tabItem: this.$route.query.tab,
      isFetching: false,
      item: {},
      originalItem: {},
      showUnsavedPrompt: false,
      formIsValid: true,
      isSaving: false,
      fetchError: null,
      synchronisationStatus: null,
      showDraftVersion: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    itemIsChanged: function itemIsChanged() {
      if (this.externalIsChanged) {
        return true;
      }

      if (!this.item || !this.originalItem) {
        console.warn('item or originalItem is not set');
        return false;
      } // we need to stringify and parse the objects to avoid reference comparison


      return !isEqual(JSON.parse(JSON.stringify(this.item)), JSON.parse(JSON.stringify(this.originalItem)));
    },
    isEditable: function isEditable() {
      return this.editMode && !this.isSaving;
    },
    computedTabs: function computedTabs() {
      var _this = this;

      return this.tabs.map(function (tab) {
        if (typeof tab === 'function') {
          return tab(_this.item, _this.originalItem);
        }

        return tab;
      });
    },
    computedHeaderButtons: function computedHeaderButtons() {
      if (typeof this.headerButtons === 'function') {
        return this.headerButtons(this.item, this.originalItem);
      }

      return this.headerButtons;
    },
    switchLabel: function switchLabel() {
      if (this.showDraftVersion) {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.versionSwitchOn');
      } else {
        return this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.versionSwitchOff');
      }
    }
  }),
  watch: {
    '$route.query.tab': function $routeQueryTab(newValue) {
      if (newValue === this.tabItem) {
        return;
      }

      this.tabItem = newValue;
    },
    tabItem: function tabItem() {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          tab: this.tabItem
        })
      });
    },
    externalFetchParams: {
      handler: function handler(newParams, oldParams) {
        if (isEqual(newParams, oldParams)) {
          return;
        }

        this.callFetchItem();
      },
      deep: true
    },
    itemIsChanged: function itemIsChanged() {
      this.$emit('item-change-state', this.itemIsChanged);
    },
    showDraftVersion: function showDraftVersion() {
      this.handleSwitchVersion(this.showDraftVersion);
    }
  },
  created: function created() {
    this.callFetchItem(true);
  },
  methods: {
    get: get,
    isEmpty: isEmpty,
    computeFunctionStringParam: function computeFunctionStringParam(val, data) {
      if (typeof val === 'undefined' || val === null) {
        return undefined;
      }

      return typeof val === 'function' ? val(data) : val;
    },
    parseAndSnackError: function parseAndSnackError(error) {
      console.error(error);
      var translationKey = get(error, 'response.data.message', get(error, 'message', '_unknown_'));

      if (translationKey === 'Network Error') {
        translationKey = 'NETWORK_ERROR';
      }

      var details = {};
      var errorKey = get(error, 'response.data.message');
      var isParameterValidationError = errorKey === 'Parameters validation error!';

      if (isParameterValidationError) {
        translationKey = 'PARAMETER_VALIDATION_ERROR';
        details.errors = get(error, 'response.data.data', []).map(function (e) {
          return e.message;
        });
        details.errorsJoined = details.errors.join(', ');
      }

      this.$snack(this.$i18n_t("Error.".concat(translationKey), details), 'error');
      return {
        translationKey: translationKey,
        details: details
      };
    },
    callFetchItem: function () {
      var _callFetchItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(showDraftVersion) {
        var parsedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.isFetching = true;
                _context.next = 4;
                return this.fetchItem(_objectSpread(_objectSpread({}, this.externalFetchParams), {}, {
                  productiveVersion: showDraftVersion ? false : true
                }));

              case 4:
                this.item = _context.sent;

                if (!isEmpty(this.templateInformation)) {
                  this.item.isProductiveVersion = !showDraftVersion;
                  this.synchronisationStatus = this.item.deviceSyncStatus;
                }

                this.originalItem = clone(this.item);
                this.fetchError = null;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                parsedError = this.parseAndSnackError(_context.t0);
                this.fetchError = parsedError;

              case 14:
                _context.prev = 14;
                this.isFetching = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10, 14, 17]]);
      }));

      function callFetchItem(_x) {
        return _callFetchItem.apply(this, arguments);
      }

      return callFetchItem;
    }(),
    updateItemByFieldKey: function updateItemByFieldKey(fieldKey, value) {
      var updatedItem = cloneDeep(this.item);
      set(updatedItem, fieldKey, value);
      this.item = updatedItem;
    },
    onCloseClick: function onCloseClick() {
      var ignoreUnsavedChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!ignoreUnsavedChanges && this.itemIsChanged) {
        this.showUnsavedPrompt = true;
      } else {
        this.$router.push(this.parentHref);
      }
    },
    discardChangesAndClose: function discardChangesAndClose() {
      this.onCloseClick(true);
    },
    onSaveClick: function () {
      var _onSaveClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isValid, redirectURL;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                isValid = this.$refs.form.validate();

                if (isValid) {
                  _context2.next = 5;
                  break;
                }

                this.$snack(this.$i18n_t('Core.DetailsPage.snacks.saveError.invalidForm'), 'error');
                return _context2.abrupt("return");

              case 5:
                this.isSaving = true;
                _context2.next = 8;
                return this.saveItem(this.item);

              case 8:
                this.item = _context2.sent;
                this.originalItem = clone(this.item);

                if (this.$route.path.endsWith('/new')) {
                  redirectURL = this.$route.path.replace('/new', "/".concat(this.item.id));

                  if (typeof this.postCreateRedirectUrlMapper === 'function') {
                    redirectURL = this.postCreateRedirectUrlMapper(this.item);
                  }

                  this.$router.push(redirectURL);
                }

                this.$snack(this.$i18n_t('Core.DetailsPage.snacks.saveSuccess', {
                  itemName: this.itemName
                }), 'success');
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                this.parseAndSnackError(_context2.t0);

              case 17:
                _context2.prev = 17;
                this.isSaving = false;
                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14, 17, 20]]);
      }));

      function onSaveClick() {
        return _onSaveClick.apply(this, arguments);
      }

      return onSaveClick;
    }(),
    resetItem: function () {
      var _resetItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.callFetchItem();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function resetItem() {
        return _resetItem.apply(this, arguments);
      }

      return resetItem;
    }(),
    onUnsavedChangesDialogButton: function onUnsavedChangesDialogButton(buttonId) {
      switch (buttonId) {
        case 'cancel':
          this.showUnsavedPrompt = false;
          break;

        case 'discard-and-close':
          this.discardChangesAndClose();
          break;

        case 'close-page':
          this.onCloseClick(true);
          break;
      }
    },
    handleSwitchVersion: function handleSwitchVersion(showDraftVersion) {
      this.callFetchItem(showDraftVersion);
    }
  }
};